module.exports = __webpack_public_path__ + "static/media/Panther460_2c.6e25b538.svg";